import axios from "axios";
import Cookies from "js-cookie";
import store from "../redux/store";
import { API_WEB_PATH } from "../constant";

const requestTimestamps = {};

const createApi = (
  baseUrl,
  { isFormData = false, canUseRepeatApi = false } = {}
) => {
  // "http://127.0.0.1:8000"
  const api = axios.create({
    baseURL: `${
      process.env.REACT_APP_ENV === "local" ? API_WEB_PATH : API_WEB_PATH
    }/api/${baseUrl}`,
    headers: {
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      Authorization: Cookies.get("token"),
    },
  });
  api.interceptors.request.use((config) => {
    const requestKey = `${config.url}_${JSON.stringify(config.params)}`;

    const currentTimestamp = Math.floor(Date.now() / 1000);
    if (
      requestTimestamps[requestKey] === currentTimestamp &&
      !canUseRepeatApi
    ) {
      const cancelSource = axios.CancelToken.source();
      config.cancelToken = cancelSource.token;
      cancelSource.cancel(`取消一樣的請求`);
    } else {
      requestTimestamps[requestKey] = currentTimestamp;
    }
    config.headers.Authorization = `Bearer ${Cookies.get("token")}`;
    return config;
  });

  api.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      console.error(error);
      if (!axios.isCancel(error)) {
        store.dispatch({ type: "API_ERROR", error: error });
      }
      if (error.response.data.message === "Invalid Authorization") {
        store.dispatch({ type: "USER_LOGOUT" });
      }
      return Promise.reject(error);
    }
  );

  return api;
};

export const api = createApi("");
export const userApi = createApi("member");
export const recordApi = createApi("record");
export const giftApi = createApi("gift");
export const transferApi = createApi("transfers");

export const transferRepeatApi = createApi("transfers", {
  canUseRepeatApi: true,
});

export const repeatApi = createApi("", {
  canUseRepeatApi: true,
});

export const formDataApi = createApi("", {
  isFormData: true,
});
